const mutations = {
  SET_LOGIN_STATUS: (state, data) => {
    state.loginStatus = data
  },
  SET_LOGIN_TYPE: (state, data) => {
    state.loginType = data
  },
  SET_Manager_ROUTER: (state, data) => {
    state.managerRouter = data
  },
  SET_COMPANY_NAME: (state, data) => {
    state.companyName = data
  },
  SET_COMPANY_LIST: (state, data) => {
    state.companyList = data
  },
}

export default mutations
